import { initReactI18next } from "react-i18next";
import i18n from "i18next";
import { THEME_CONFIG } from "configs/AppConfig";
import antdZhCn from "antd/es/locale/zh_CN";
import antdJaJP from "antd/es/locale/ja_JP";
import antdFrFR from "antd/es/locale/fr_FR";
import antdEnUS from "antd/es/locale/en_US";

import zh from "./locales/zh_CN.json";
import ja from "./locales/ja_JP.json";
import fr from "./locales/fr_FR.json";
import en from "./locales/en_US.json";

export const resources = {
  en: {
    antd: antdEnUS,
    translation: en,
  },
  fr: {
    antd: antdFrFR,
    translation: fr,
  },
  ja: {
    antd: antdJaJP,
    translation: ja,
  },
  zh: {
    antd: antdZhCn,
    translation: zh,
  },
};

i18n.use(initReactI18next).init({
  fallbackLng: THEME_CONFIG.locale,
  interpolation: {
    escapeValue: false,
  },
  lng: THEME_CONFIG.locale,
  resources,
});

export default i18n;
